<template>
  <div>
    <div class="mx-auto mt-16 pt-1" :class="isMobile ? 'w-full px-2' : 'section'">
      <div v-if="data" class="mt-8 ml-4">
        <div v-html="data"></div>
      </div>
    </div>
    <div class="text-center">
      <button class="w-20 px-3 mb-2 font-bold border-2 rounded-md bg-white cursor-pointer" @click="close">
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      data: null,
    }
  },
  computed: mapGetters({
    isMobile: 'getIsMobile',
  }),
  async mounted() {
    this.$store.commit('setIsLoading', true);
    try {
      const response = await this.getData('./data/update.txt');
      this.data = response.split('\n').join('<br />');
    } catch (response) {
      console.log(response);
    } finally {
      this.$store.commit('setIsLoading', false);
    }
  },
  methods: {
    getData: function (fname) {
      return new Promise((resolve) => {
        fetch(fname)
          .then(res => res.text())
          .then(data => {
            resolve(data);
          });
      });
    },
    close: function () {
      window.close();
    },
  }
}
</script>

<style scoped>
.section {
  width: 60rem;
}
</style>
